import React from 'react';
import { Route } from 'react-router-dom';
import { ContainerWrapper } from '../../components';
import { Col, Row } from 'reactstrap';
import StatstypeList from './StatstypeList/StatstypesList';
import "./Stats.css";

const Stats = ({ match }) => {
    return (
        <div className="Stats">
            <ContainerWrapper container="stats">
                <Route exact path={ match.path } component={StatstypeList} />
            </ContainerWrapper>
        </div>
    );
}

export default Stats;
